/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, May 20th 2022, 7:54:47 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { OSAlert } from "ui-widgets/alerts/Alert";

export const VerificationEmailSent = () => {
  return (
    <div style={{ marginRight: "20px", marginLeft: "20px" }}>
      <OSAlert severity="success" variant="filled" alertTitle={<>Verification Email Sent</>}>
        <p>
          A veritification email has been sent to the provided email address. Kindly click on the link provided in the
          email to verify your email address and continue setting up your account.
        </p>
        <p>If you do not receive the email within a few minutes, please check your junk/spam email folder.</p>
      </OSAlert>
    </div>
  );
};
